import { Checkbox } from 'antd';
import React, { useId, useState } from 'react';
import styled from 'styled-components';
import type { CheckboxChangeEvent } from 'antd/es/checkbox';

type ContainerProps = {
    $isVoted: boolean;
    $showCorrectAnswer: boolean;
    $showResult: boolean;
    $rate?: number;
    $isBestAnswer: boolean;
};

const shouldShowResult = ($isVoted: boolean, $showResult: boolean) => {
    return $isVoted && $showResult;
};
const shouldShowCorrectAnswer = ($showCorrectAnswer: boolean, $isBestAnswer: boolean) => {
    return $showCorrectAnswer && $isBestAnswer;
};

const Container = styled.div<ContainerProps>`
    ${({ $isVoted, $rate, $showCorrectAnswer, $showResult, $isBestAnswer }) =>
        (shouldShowResult($isVoted, $showResult) ||
            shouldShowCorrectAnswer($showCorrectAnswer, $isBestAnswer)) &&
        `background: ${getCardBackgroundColor($rate)}`};
    width: 100%;
    padding: 15px;
    :hover {
        ${({ $isVoted, theme }) => !$isVoted && `background: ${theme.colors.greyishBrown}`};
    }
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    justify-content: flex-start;
`;

const Label = styled.label`
    display: block;
    padding-left: 15px;
    align-items: center;
    flex: 12;
    p {
        padding: 0;
        margin: 0;
    }
`;

const getCardBackgroundColor = (rate: number) => {
    switch (rate) {
        case 0:
            return 'red';
        case 1:
            return 'green';
        default:
            return 'grey';
    }
};

type Props = {
    $item: ContestQuestion;
    $isLocked?: boolean;
    $showCorrectAnswer?: boolean;
    $showResult?: boolean;
    $canUnVote?: boolean;
    $isBestAnswer?: boolean;
    onVote: () => void;
    onUnVote?: () => void;
};

export const CheckboxItem = ({
    $item,
    $isLocked = false,
    onVote,
    onUnVote,
    $showCorrectAnswer = false,
    $showResult = false,
    $canUnVote = true,
    $isBestAnswer
}: Props) => {
    const domId = useId();
    const [checked, setChecked] = useState<boolean>(false);

    const handleChange = (e: CheckboxChangeEvent) => {
        const isChecked = e.target.checked;
        setChecked(isChecked);
        if (isChecked === false) {
            onUnVote();
            return;
        }
        if ($isLocked) return;
        onVote();
    };

    const isDisabled = $isLocked && $canUnVote ? !checked : $isLocked;
    return (
        <Container
            $isVoted={checked}
            $showCorrectAnswer={$showCorrectAnswer}
            $rate={$item.rating}
            $showResult={$showResult}
            $isBestAnswer={$isBestAnswer}
        >
            <Checkbox
                id={domId}
                checked={checked}
                type="checkbox"
                onChange={handleChange}
                disabled={isDisabled}
                value={$item.slug}
            />
            <Label htmlFor={domId} dangerouslySetInnerHTML={{ __html: $item.content }} />
        </Container>
    );
};

export default CheckboxItem;
